/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AssetsLinkedPublishedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Assets Linked Published',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m20.689 28.358 7.745 4.317a.7.7 0 0 0 .938-.312L34.9 18.6ZM18 29.182v6.34a.426.426 0 0 0 .7.325l4.535-3.857ZM7.662 24H4V4h28v10.506l2-.611V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h7.737Z"
    />
    <path
      d="m33.949 17.052-21.921 6.742a.349.349 0 0 0-.056.647l6.064 2.966ZM14.474 8.015h-.725a6.758 6.758 0 0 0-3.367.97A5.311 5.311 0 0 0 8.234 11.5a4.227 4.227 0 0 0-.156 2.4 5.187 5.187 0 0 0 2.534 3.252 9.092 9.092 0 0 0 4.616.831l1.588-.105-1.456-1.83a9.815 9.815 0 0 1-2.787-.231 3.569 3.569 0 0 1-2.309-1.612 2.637 2.637 0 0 1 .072-2.552 3.985 3.985 0 0 1 3.2-1.615c.111-.008.74-.014.852-.017a4.937 4.937 0 0 1 2.42.488 3.018 3.018 0 0 1 1.644 2.172 1.552 1.552 0 0 0 .178.71.982.982 0 0 0 .376.288 2.962 2.962 0 0 0 1.435.307 4.887 4.887 0 0 0-1.621-4.423 6.542 6.542 0 0 0-4.346-1.548Z"
    />
    <path
      d="M21.567 18.011h.725a6.758 6.758 0 0 0 3.367-.97 5.311 5.311 0 0 0 2.149-2.511 4.227 4.227 0 0 0 .156-2.4 5.187 5.187 0 0 0-2.534-3.26 9.092 9.092 0 0 0-4.616-.831l-1.588.105 1.456 1.83a9.815 9.815 0 0 1 2.787.231 3.569 3.569 0 0 1 2.309 1.612 2.637 2.637 0 0 1-.072 2.552 3.985 3.985 0 0 1-3.2 1.615c-.111.008-.74.014-.852.017a4.937 4.937 0 0 1-2.42-.488 3.018 3.018 0 0 1-1.644-2.172 1.552 1.552 0 0 0-.178-.71.982.982 0 0 0-.376-.288 2.962 2.962 0 0 0-1.435-.307 4.887 4.887 0 0 0 1.621 4.423 6.542 6.542 0 0 0 4.345 1.552Z"
    />
  </svg>`;
};
